import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type ContextValueType } from '../types';
import META from './useTrackContextValueDeleted.meta';

export type UseTrackContextValueDeletedParams = {
  source: 'manual';
  value_type: ContextValueType;
  field_name: string;
};

export const useTrackContextValueDeleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackContextValueDeleted = useCallback(
    (params: UseTrackContextValueDeletedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackContextValueDeleted };
};
